import { Link } from 'react-router-dom';

interface SidebarNavItemProps {
  href: string;
  icon: string;
  label: string;
  isActive: boolean;
  isCollapsed?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const SidebarNavItem = ({ href, icon, label, isActive, isCollapsed = false, onClick }: SidebarNavItemProps) => {
  return (
    <Link
      to={href}
      title={isCollapsed ? label : ''}
      onClick={onClick}
      className={`flex items-center rounded-lg py-2 text-sm font-medium transition-colors ${
        isCollapsed ? 'justify-center px-2' : 'gap-3 px-3'
      } ${
        isActive
          ? 'font-bold text-white bg-primary'
          : 'text-gray-600 hover:bg-primary/10 hover:text-primary'
      }`}
    >
      <span className="material-symbols-outlined text-base">{icon}</span>
      {!isCollapsed && label}
    </Link>
  );
};
